// PARAQTA · Экрандағы JS қателерін серверге жазу (02.11.2026, founder: «қателерді біз білмейміз»).
// Бұрын телефонда болған қате ешқайда жазылмайтын — тек founder өзі көрсе ғана білетінбіз.
// Жаңа backend жоқ: бар /api/track → events кестесі, event='js_error'. Қарау:
//   SELECT date(created_at), json_extract(meta,'$.msg'), COUNT(*) FROM events WHERE event='js_error' GROUP BY 1,2 ORDER BY 3 DESC;
// Шектеу: бір бет ашылғанда ≤ 5 қате, бір хабар бір рет. Жеке дерек жоқ (URL-дің query-сі мен сандар қиылады).
import { track } from './track.js';

const MAX = 5;
const seen = new Set();
let sent = 0;
// шу: браузер кеңейтімдері, бөтен домен скрипттері, ResizeObserver ескертуі, желі үзілгенде fetch
const NOISE = /ResizeObserver loop|^Script error\.?$|chrome-extension:|moz-extension:|safari-extension:|webkit-masked-url|Failed to fetch$|Load failed$|NetworkError when attempting/i;

const clip = (s, n) => String(s || '').replace(/https?:\/\/[^\s)]+/g, u => u.split('?')[0]).replace(/\b\d{5,}\b/g, '#').slice(0, n);
const file = (s) => String(s || '').split('?')[0].split('/').slice(-2).join('/');
const device = () => {
  const ua = navigator.userAgent || '';
  return /PARAQTA-App\//.test(ua) ? 'app' : /iPhone|iPad/.test(ua) ? 'ios' : /Android/.test(ua) ? 'android' : 'desktop';
};

function report(kind, msg, src, line, col, stack) {
  try {
    const m = clip(msg, 200);
    if (!m || NOISE.test(m) || sent >= MAX) return;
    const key = kind + '|' + m;
    if (seen.has(key)) return;
    seen.add(key); sent++;
    track('js_error', {
      kind, msg: m, src: file(src), line: line || 0, col: col || 0,
      stack: clip(stack, 400), page: location.pathname + (location.hash || '').slice(0, 30), dev: device(),
    });
  } catch (_) {}
}

export function initErrlog() {
  if (window.__pqErrlog) return;
  window.__pqErrlog = true;
  window.addEventListener('error', (e) => {
    if (e.target && e.target !== window && (e.target.src || e.target.href)) return;   // сурет/скрипт жүктелмеуі — бөлек мәселе
    report('error', e.message, e.filename, e.lineno, e.colno, e.error && e.error.stack);
  });
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason;
    report('promise', r && (r.message || r), '', 0, 0, r && r.stack);
  });
}

// импорт еткен бойда іске қосылады — main.js-те ЕҢ БІРІНШІ импорт, сонда басқа модульдердің жүктелу қатесі де ұсталады
initErrlog();
